











import { Component, Prop, Mixins, Ref } from "vue-property-decorator";
import { IContract, IContractProduct } from "@/models/contracts";
import RequestPromises from "@/mixins/requestPromises";
import InvoicesListing from "@/components/app/global/invoices/invoicesListing.vue";
import { IFraudEvent } from "@/models/fraud";

@Component({
  components: {
    InvoicesListing
  }
})
export default class ContractProductInvoices extends Mixins(RequestPromises) {
  // Refs

  @Ref()
  public invoicesListing!: InvoicesListing;

  // Props

  @Prop({ default: "" })
  public clientId!: IContract["client_id"];

  @Prop({ required: true })
  public contractId!: IContract["id"];

  @Prop({ required: true })
  public productId!: IContractProduct["id"];

  // Life-cycle methods

  public created() {
    this.$bus.$on(`new-fraud-event`, this.fraudEventListener);
  }

  public beforeDestroy() {
    this.$bus.$off(`new-fraud-event`, this.fraudEventListener);
  }

  public fraudEventListener(event: IFraudEvent) {
    if (
      event.contract_id === this.contractId ||
      event.client_id === this.clientId
    )
      this.invoicesListing && this.invoicesListing.reloadData();
  }
}
